import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
interface ButtonProps extends Omit<HTMLMotionProps<'button'>, 'href'> {
  variant?: 'primary' | 'secondary' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
  href?: string;
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  className = '',
  href,
  children,
  ...props
}: ButtonProps) {
  const base = 'inline-flex items-center justify-center font-semibold rounded-xl transition-all focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-sky disabled:opacity-50';
  const variants = {
    primary: 'bg-brand-sky text-white hover:bg-brand-deep shadow-lg shadow-brand-sky/20',
    secondary: 'bg-brand-slate-800 text-white hover:bg-brand-slate-900',
    ghost: 'bg-transparent text-brand-slate-700 hover:bg-brand-slate-100'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  const combinedClassName = `${base} ${variants[variant]} ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className}`;
  if (href) {
    return <motion.a href={href} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className={combinedClassName} style={{
      textDecoration: 'none'
    }} data-id="element-246">
        {children}
      </motion.a>;
  }
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={combinedClassName} {...props} data-id="element-247">
      {children}
    </motion.button>;
}